var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack4Solid25({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,8.89a5,5,0,0,1,.36-2,3.74,3.74,0,0,1,.73-1.08,3.1,3.1,0,0,1,1-.7A4.3,4.3,0,0,1,8,4.77a3.68,3.68,0,0,1,2.78,1.08,4.13,4.13,0,0,1,1.05,3,4.13,4.13,0,0,1-1,3A3.65,3.65,0,0,1,8,12.92a3.71,3.71,0,0,1-2.79-1.07A4.09,4.09,0,0,1,4.2,8.89Zm1.64-.05a2.92,2.92,0,0,0,.62,2A2,2,0,0,0,8,11.56a2,2,0,0,0,1.56-.69,3,3,0,0,0,.61-2,2.94,2.94,0,0,0-.59-2A2,2,0,0,0,8,6.13a2,2,0,0,0-1.58.68A3,3,0,0,0,5.84,8.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack4Solid25);
export default __webpack_public_path__ + "static/media/Symbolpack_4_solid_25.bf27a2ab4db4dc7044d3f7e0c72720eb.svg";
export { ForwardRef as ReactComponent };